const bodyLockClass = 'is-locked';

const pageLock = (willLock = false) => {
  const body = document.body;

  if (willLock) {
    body.classList.add(bodyLockClass);
  } else {
    body.classList.remove(bodyLockClass);
  }
};

export default pageLock;



// WEBPACK FOOTER //
// ./src/utils/pageLock.js